const e = Symbol(), o = Symbol();
export {
  e as themeKey,
  o as themeLoadedKey
};
//# sourceMappingURL=injection-symbol.js.map
